<div class="common-rate-style">
  <div class="title">
      {{ 'lang.reporting.categoriesPie' | translate }}
  </div>
  <div class="category-pie">
  <canvas  id="myPieCategories" ></canvas>
  <img hidden id="pieCategoryChart"/>
</div>
</div>
